import FieldObject from './FieldObject.js'
import moment from 'moment'

export default class SimpleField extends FieldObject {
  fillRef (model, data, onChange) {
    if (this.type === 'DATE') {
      let date = data && moment(data).set({hour: 10, minute: 0}).format('YYYY-MM-DD HH:mm') || null
      var refs = this.cxt.refMap.get(this.name)
      if (refs) {
        refs.forEach(r => {
          let fobj = this.cxt.fieldObjects.get(r)
          let obj, code
          if (fobj.type === 'ACTION') {
            obj = fobj.getValue(model)
            obj = Object.assign(obj, {input: date != null ? 'true' : 'false', inputted: date})
            if (!obj.logId) {
              code = obj
              fobj.setValue(
                model,
                code,
                obj,
                onChange
              )
            }
          } else {
            fobj.setValue(
              model,
              code,
              obj,
              onChange
            )
          }
        })
      }
    }
    this.cxt.updateItems(model)
  }
}



// WEBPACK FOOTER //
// ./src/components/assist/fields/SimpleField.js